export const PrincipalActions = {
  GET_ABOUTPRINCIPAL: "GET_ABOUTPRINCIPAL",
  SET_ABOUTPRINCIPAL: "SET_ABOUTPRINCIPAL",
};
